/* eslint-disable no-underscore-dangle */
import { addFlashMessageForNextPageLoad } from 'utils/cookies';

import { HttpError } from './HttpError';
import { RichError } from './RichError';

const handleErrors = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  status: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  url: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolve: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reject: any,
  options = {},
) => {
  if (status > 199 && status < 300) {
    resolve();
    return;
  }

  // @ts-expect-error TS(2339): Property 'skipRedirects' does not exist on type '{... Remove this comment to see the full error message
  if (options.skipRedirects) {
    reject();
    return;
  }

  let loginPath = '/login';
  let homePath = `/${CURRENT_LOCALE}/`;

  if (window.location.pathname.startsWith('/fair')) {
    homePath = '/fair';
    loginPath = '/fair/login';
  }

  if (/\/[^/]/.test(url)) {
    // don't redirect on 401/403 for algolia requests
    if (status === 401) {
      addFlashMessageForNextPageLoad('LOGIN_REQUIRED');
      // @ts-expect-error TS(2322): Type 'string' is not assignable to type '(string |... Remove this comment to see the full error message
      window.location = loginPath;
      return;
    }

    if (status === 403) {
      addFlashMessageForNextPageLoad('FORBIDDEN');
      // @ts-expect-error TS(2322): Type 'string' is not assignable to type '(string |... Remove this comment to see the full error message
      window.location = homePath;
      return;
    }

    if (
      (status === 408 ||
        /* Request Timeout */
        status >= 500) &&
      // @ts-expect-error TS(2339): Property 'retriesRemaining' does not exist on type... Remove this comment to see the full error message
      options.retriesRemaining
    ) {
      setTimeout(() => {
        // TODO: Fix this the next time the file is edited.
        // @ts-expect-error TS(2339): Property 'retriesRemaining' does not exist on type... Remove this comment to see the full error message
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        getJsonInternal(url, resolve, reject, options.retriesRemaining - 1);
      }, 1000);
      return;
    }

    reject();
    return;
  }

  reject();
};

export const initXMLHttpRequestActiveCounter = () => {
  // @ts-expect-error TS(2339): Property '_allRequests' does not exist on type '{ ... Remove this comment to see the full error message
  XMLHttpRequest._allRequests = [];
  // @ts-expect-error TS(2339): Property '_completedRequests' does not exist on ty... Remove this comment to see the full error message
  XMLHttpRequest._completedRequests = [];
  const oldOpen = XMLHttpRequest.prototype.open;

  // @ts-expect-error TS(2322): Type '(args_0: string, args_1: string | URL, args_... Remove this comment to see the full error message
  XMLHttpRequest.prototype.open = function open(...args) {
    // TODO: Fix this the next time the file is edited.
    // @ts-expect-error TS(2339): Property '_url' does not exist on type 'XMLHttpReq... Remove this comment to see the full error message
    // eslint-disable-next-line prefer-destructuring
    this._url = args[1];
    // @ts-expect-error TS(2345): Argument of type '[string, string | URL, unknown, ... Remove this comment to see the full error message
    oldOpen.apply(this, args);
  };

  const oldSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.send = function send(...args) {
    // @ts-expect-error TS(2339): Property '_url' does not exist on type 'XMLHttpReq... Remove this comment to see the full error message
    if (!this._url.includes('sockjs-node')) {
      // @ts-expect-error TS(2339): Property '_allRequests' does not exist on type '{ ... Remove this comment to see the full error message
      XMLHttpRequest._allRequests.push(this._url);

      this.addEventListener('loadend', () => {
        setTimeout(() => {
          // @ts-expect-error TS(2339): Property '_completedRequests' does not exist on ty... Remove this comment to see the full error message
          XMLHttpRequest._completedRequests.push(this._url);
        }, 1);
      });
    }

    oldSend.apply(this, args);
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const checkVersion = (version: any) => {
  if (version > window.Idealist._version) {
    window.Idealist.forceUpdate({
      oldVersion: window.Idealist._version,
      newVersion: version,
    });
  }
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function parseJsonResponse(xhr: any, reject: any) {
  if (!xhr.responseText) {
    return null;
  }

  if (xhr.getResponseHeader('Content-Type').indexOf('json') < 0) {
    reject(
      new RichError('Invalid Content-Type for JSON response', {
        responseURL: xhr.responseURL,
        contentType: xhr.getResponseHeader('Content-Type'),
      }),
    );
  }

  try {
    const json = JSON.parse(xhr.responseText);
    checkVersion(json._version);
    return json;
  } catch (err) {
    reject(
      new RichError('Error parsing JSON response', {
        responseURL: xhr.responseURL,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        errorMessage: err.message,
      }),
    );
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getJson<T = unknown>(url: any): Promise<T> {
  return new Promise((resolve, reject) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    getJsonInternal(
      url,
      resolve,
      reject,
      5,
      /* retriesRemaining */
    );
  });
}

const getJsonInternal = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  url: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resolve: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reject: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  retriesRemaining: any,
) => {
  const xhr = new XMLHttpRequest();
  xhr.addEventListener('load', () => {
    handleErrors(
      xhr.status,
      url,
      () => resolve(parseJsonResponse(xhr, reject)),
      () => reject(new HttpError('GET', url, xhr)),
      {
        retriesRemaining,
      },
    );
  });
  xhr.open('GET', url, true);
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.send();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postData = (url: any, formData: any) => {
  const retriesRemaining = 1;
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      handleErrors(
        xhr.status,
        url,
        () => resolve(xhr.responseText),
        () => reject(new HttpError('GET', url, xhr)),
        {
          retriesRemaining,
        },
      );
    });
    xhr.open('POST', url, true);
    xhr.send(formData);
  });
};
export function postJson<T = unknown>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  url: any,
  data = {},
  options = {},
): Promise<T> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      handleErrors(
        xhr.status,
        url,
        () => resolve(parseJsonResponse(xhr, reject)),
        () => reject(new HttpError('POST', url, xhr)),
      );
    });
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');

    // @ts-expect-error TS(2339): Property 'headers' does not exist on type '{}'.
    if (options.headers && Object.keys(options.headers).length > 0) {
      // @ts-expect-error TS(2339): Property 'headers' does not exist on type '{}'.
      Object.entries(options.headers).forEach(([k, v]) => {
        // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
        xhr.setRequestHeader(k, v);
      });
    }

    xhr.send(JSON.stringify(data));
  });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putJson<TData>(url: any, data: any) {
  return new Promise<TData>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      handleErrors(
        xhr.status,
        url,
        () => resolve(parseJsonResponse(xhr, reject)),
        () => reject(new HttpError('PUT', url, xhr)),
      );
    });
    xhr.open('PUT', url, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(data));
  });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function patchJson<TData>(url: any, data: any) {
  return new Promise<TData>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      handleErrors(
        xhr.status,
        url,
        () => resolve(parseJsonResponse(xhr, reject)),
        () => reject(new HttpError('PATCH', url, xhr)),
      );
    });
    xhr.open('PATCH', url, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(data));
  });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function post(url: any, data: any, options = {}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      handleErrors(
        xhr.status,
        url,
        () => resolve(xhr.responseText),
        () => reject(new HttpError('POST', url, xhr)), // don't redirect on 401/403 for algolia requests
        {
          skipRedirects: !/^\/[^/]/.test(url),
        },
      );
    });
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Accept', 'application/json');

    // @ts-expect-error TS(2339): Property 'contentType' does not exist on type '{}'... Remove this comment to see the full error message
    if (options.contentType !== false) {
      xhr.setRequestHeader(
        'Content-Type',
        // @ts-expect-error TS(2339): Property 'contentType' does not exist on type '{}'... Remove this comment to see the full error message
        options.contentType || 'application/x-www-form-urlencoded',
      );
    }

    xhr.send(data);
  });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function del<TData = unknown>(url: any) {
  return new Promise<TData>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      handleErrors(
        xhr.status,
        url,
        () => {
          if (xhr.responseText) {
            resolve(JSON.parse(xhr.responseText));
          } else {
            // @ts-expect-error TS(2794): Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
            resolve();
          }
        },
        () => reject(new HttpError('DELETE', url, xhr)),
      );
    });
    xhr.open('DELETE', url, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.send();
  });
}
/* eslint-enable no-underscore-dangle */
